import FindAgentBlock from '../components/FindAgentBlock';

import React, { useRef } from 'react'

import useScrollSpy from 'react-use-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import '../assets/styles/pages/_info-page.scss'

export const TermsOfUse = () => {
  const sectionRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: 0
  });

  const sideMenuItems = [
    { id: 1, text: 'Terms and Conditions of Use of This Website', url: '#anchor1' },
    { id: 2, text: 'Disclaimer of Warranty and Limitation of Liability', url: '#anchor2' },
    { id: 3, text: 'Indemnification', url: '#anchor3' },
    { id: 4, text: 'No Professional Advice', url: '#anchor4' },
    { id: 5, text: 'Links', url: '#anchor5' },
  ]

  const cards = [
    {
      id: 1,
      anchor: 'anchor1',
      mainTitle: 'Terms and Conditions of Use of This Website',
      content: [
        {
          type: 'paragraph',
          value: 'These Terms of Use (“TOU“, “Terms“) are between you and RVOS Farm Mutual Insurance Company (“RVOS”) and its subsidiaries and group of companies (“we,” “us,” “our” and “RVOS”) concerning your use and access of this website and any other website owned or operated by or on behalf of RVOS (“website,” “site”). These Terms apply to all users of the website, including visitors, agents, and other authorized users.'
        },
        {
          type: 'paragraph',
          value: 'BY ACCESSING AND USING THIS WEBSITE, YOU ACKNOWLEDGE THAT YOU ACCEPT AND AGREE TO THESE TERMS, WITHOUT EXCEPTION. IF YOU DO NOT AGREE TO ABIDE BY THESE TERMS, YOU SHOULD CEASE ALL USE AND ACCESS OF THIS WEBSITE IMMEDIATELY.'
        },
        {
          type: 'paragraph',
          value: 'RVOS may, at any time and without notice to you, modify these Terms of Use. We reserve the right to add, remove or change any and all aspects, features or content of this website and the rules and regulations governing its access and use, including termination of all or part of this site, without notice to you. By continuing to access and use this website after such changes are made, you will be deemed to have accepted such changes.'
        },
        {
          type: 'paragraph',
          value: 'You acknowledge that your access and use of this site, including information you transmit to this site, may be subject to access by, or disclosure to, other persons, including, but not limited to, agents, sales representatives, and employees. Without limiting any other disclaimer herein, RVOS shall not be responsible or liable for any harm that you or any other person may suffer in connection with any such breach of confidentiality or security.'
        },
        {
          type: 'paragraph',
          value: 'If you are accessing and using this website on behalf of a company or other organization, you represent that you have the legal authority to bind such company or organization to these Terms of Use. If you are an agent of RVOS, certain agent-specific terms and conditions may apply to you and may supersede these Terms of Use.'
        },
        {
          type: 'paragraph',
          value: 'If you are an authorized user with access to a restricted area, you are responsible for the security, protection and confidentiality of your password, User ID, and all other personal or identifiable information. You agree to protect this information and notify us immediately if you know or suspect this information has been compromised. Under no circumstances is RVOS liable for any unauthorized access to your personal information.'
        },
        {
          type: 'paragraph',
          value: 'You may not store, modify, reverse engineer, disassemble, reproduce, transmit, distribute, post, publish, publicly display or provide access to any information, documents, content or images obtained from this website. You agree not to engage in any activities in a fraudulent, illegal, malicious or negligent manner when using or accessing this site. RVOS reserves all rights with respect to this website and may pursue all legally available options under both criminal and civil laws, including cooperation with law enforcement, in the event of any violation(s).'
        },
      ]
    },
    {
      id: 2,
      anchor: 'anchor2',
      mainTitle: 'Disclaimer of Warranty and Limitation of Liability',
      content: [
        {
          type: 'paragraph',
          value: 'This website, and all content, information, documents, software, calculators, products or services available through this website (hereafter known as “Materials”), are provided on an “as is” and “as available” basis, without any warranty of any kind, either expressed or implied, including and without limitation, the implied warranties of merchantability, fitness for a particular purpose, and accuracy.'
        },
        {
          type: 'paragraph',
          value: 'RVOS does not ENDORSE, NOR MAKE ANY WARRANTY, AS TO THE ACCURACY, COMPLETENESS, CURRENCY OR RELIABILITY OF THE MATERIALS. We do not warrant or guarantee that this website will be uninterrupted, complete, reliable or error-free. We do not warrant or guarantee that defects will be corrected; that our websites, or the servers that make them available, are free of computer viruses or other harmful components or conditions; or that information contained in the website is accurate as of any particular date. You are responsible for taking all necessary precautions to ensure that Materials you may obtain are free of viruses or other harmful components.'
        },
        {
          type: 'paragraph',
          value: 'Any risk arising out of use or performance of the Materials remains entirely with you, and under no circumstances will RVOS be liable for any damages whatsoever arising out of their access, use or performance, even if we have been negligent.'
        },
        {
          type: 'paragraph',
          value: 'RVOS SPECIFICALLY DISCLAIMS ANY LIABILITY, WHETHER BASED IN CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR SPECIAL DAMAGES ARISING OUT OF, OR IN ANY WAY CONNECTED WITH, ACCESS TO, USE OF OR RELIANCE ON THE MATERIALS (EVEN IF RVOS OR AN RVOS REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES) OR THAT ARISE IN CONNECTION WITH MISTAKES OR OMISSIONS IN, OR DELAYS IN TRANSMISSION OF, INFORMATION TO OR FROM THE USER, INTERRUPTIONS IN TELECOMMUNICATIONS CONNECTIONS TO OR FROM THIS WEBSITE OR VIRUSES THAT MAY INFECT YOUR COMPUTER EQUIPMENT OR OTHER PROPERTY, WHETHER CAUSED IN WHOLE OR IN PART BY NEGLIGENCE, ACTS OF GOD, TELECOMMUNICATIONS, SOFTWARE OR EQUIPMENT FAILURE, THEFT OR DESTRUCTION OF, OR UNAUTHORIZED ACCESS TO THIS WEBSITE OR THE MATERIALS.'
        }
      ]
    },
    {
      id: 3,
      anchor: 'anchor3',
      mainTitle: 'Indemnification',
      content: [
        {
          type: 'paragraph',
          value: 'You agree to defend, hold harmless and indemnify RVOS from any and all third-party claims, liability, damages, expenses and costs, including, but not limited to, reasonable legal fees, caused by or arising from your use of this website or the Materials in a manner not expressly authorized by these Terms of Use or that violates these Terms of Use, any law, or the rights of a third party.'
        }
      ]
    },
    {
      id: 4,
      anchor: 'anchor4',
      mainTitle: 'No Professional Advice',
      content: [
        {
          type: 'paragraph',
          value: 'The information contained in the Materials is not a complete description of all terms, exclusions and conditions applicable to the products and services offered by RVOS but are provided solely for general informational purposes. It is not offered as legal, accounting, or other professional advice and is not tailored to your specific circumstance. You should evaluate all information, opinions and advice available on this website in consultation with your authorized RVOS insurance agent. Please refer to the actual policy or relevant services agreement for the governing terms.'
        }
      ]
    },
    {
      id: 5,
      anchor: 'anchor5',
      mainTitle: 'Links',
      content: [
        {
          type: 'paragraph',
          value: 'RVOS may offer links to websites operated by other entities and which are entirely independent of this site. We make no representation regarding the content, legitimacy, availability, functionality or accuracy of any website you may access through this one, and we are not responsible for the content found on other sites that are linked from this website. We provide these links as a convenience to you, and inclusion of these links on this website does not imply endorsement, recommendation, advocacy, affirmation, approval or sponsorship for any linked website or the services, products, content or advice described on the site. The views, opinions, statements, offers or other information or content expressed therein are strictly those of the respective author(s), creator(s) or distributor(s) and not RVOS. RVOS reserves the right to terminate a link to a third-party website at any time. The third-party sites are not controlled in any way by RVOS and may have different terms of use and privacy policies, which we encourage you to review.'
        }
      ]
    }
  ];

  const getList = (item) => {
    return (
        <ul>
          {item.list.map(li => {
            return (
                <li dangerouslySetInnerHTML={{__html: li}}/>
            )
          })}
        </ul>
    )
  }

  const toggleOpen = (e) => {
    e.target.closest('.main-card').classList.toggle('open');
  }

  return (
      <>
        <div className="info-page terms-of-use">
          <div className="header-block">
            <div className="main-title">TERMS OF USE</div>
          </div>
          <div className="main-block">
            <aside>
              <ul>
                {
                  sideMenuItems.map((item, index) => {
                    return <li key={item.id}>
                      <AnchorLink
                          className={activeSection === index ? 'active' : ''}
                          href={item.url}
                          offset={-20}
                      >
                        {item.text}
                      </AnchorLink>
                    </li>
                  })
                }
              </ul>
            </aside>
            <main>
              <div className="main-list">
                {
                  cards.map((item, index) => {
                    return (
                        <div className="main-card" key={item.id} >
                          <div className="main-card__ref" id={item.anchor} ref={sectionRefs[index]}/>
                          <div className="title-line" onClick={(e) => toggleOpen(e)}>
                            <div className="title-main">{item.mainTitle}</div>
                          </div>
                          <div className="main-card__content">
                            {item.content.map(contentItem => {
                              if (contentItem.type === 'paragraph') {
                                return (
                                    <p dangerouslySetInnerHTML={{__html: contentItem.value}}/>
                                )
                              }
                              if (contentItem.type === 'list') {
                                return getList(contentItem);
                              }
                            })}
                          </div>
                        </div>
                    )
                  })
                }
              </div>
            </main>
          </div>
          <FindAgentBlock />
        </div>
      </>
  );
}
